const defaultSort = schools => schools;
const defaultMutator = schools => schools;

const alphabeticalSort = schools => schools.sort((a, b) => a._epi.title.localeCompare(b._epi.title))

export const PROCESSOR_RESET_ACTION = 'reset';
export const PROCESSOR_SET_SORT_ACTION = 'setSearch';
export const PROCESSOR_SET_MUTATOR_ACTION = 'setMutator';
export const PROCESSOR_TIER_PROCESS = 'setTier';
export const PROCESSOR_SET_GOCPS = 'setGocps';

function createTopSort(topIds) {
    return (schools) => {
        const sorted = schools.reduce((acc, element) => {
            if (topIds.includes('' + element._epi.id)) {
                return [element, ...acc];
            }
            return [...acc, element];
        }, []);
        return sorted;
    }
}

function createAddTier(ids) {
    return (schools) => {
        return schools.map(school => {
            if (ids.includes('' + school._epi.id)) {
                const s = {
                    ...school,
                    _tag: "Neighborhood School"
                }
                return s;
            }
            return school;
        })
    }
}

export const processorDefaultState = {
    sort: defaultSort,
    mutator: defaultMutator,
    _defaults: { // these defaults are what we initialize back to on reset. 
        sort: defaultSort,
        mutator: defaultMutator
    }
}

export const gocpsProcessorDefaultState = {
    sort: alphabeticalSort,
    mutator: defaultMutator,
    _defaults: { // these defaults are what we initialize back to on reset. Can be changed runtime
        sort: alphabeticalSort,
        mutator: defaultMutator
    }
}

export function processorReducer(state, payload) {
    switch (payload.action) {
        case PROCESSOR_RESET_ACTION:
            return { ...state, sort: state._defaults.sort, mutator: state._defaults.mutator };
        case PROCESSOR_SET_SORT_ACTION:
            return { ...state, sort: payload.sortFunction };
        case PROCESSOR_SET_MUTATOR_ACTION:
            return { ...state, mutator: payload.mutatorFunction };
        case PROCESSOR_SET_GOCPS:
            return gocpsProcessorDefaultState;
        case PROCESSOR_TIER_PROCESS:
            return {
                ...state,
                sort: createTopSort(payload.tierIds),
                mutator: createAddTier(payload.tierIds),
            }
    }
}